<template>
  <div>
    <h1>
      <b>Equipos</b>
    </h1>
    <div class="form-group pull-left">
      <router-link to="/tarjetas/crear">
        <button type="button" class="btn btn-success md-elevation-24">
          <i class="fa fa-plus-circle"></i> Crear equipo
        </button>
      </router-link>
    </div>
    <div>
      <div class="form-group pull-right">
        <input
          type="text"
          class="search form-control"
          v-model="filter"
          placeholder="Buscar tarjeta"
        />
      </div>
      <span class="counter pull-right"></span>
      <div class="row">
        <div id="table" class="col-xs-12 table-responsive">
          <datatable
            :columns="columns"
            :data="row"
            :filter-by="filter"
            class="table table-hover table-bordered results"
          >
            <template scope="{ row }">
              <tr>
                <td class="td_style">{{ row.id }}</td>
                <td class="td_style">
                  <router-link
                    :to="{
                      name: 'editar-tarjetas',
                      params: { tarjetaId: row.id },
                    }"
                  >
                    <a href="#">{{ `${row.marcas.marca}` }}</a>
                  </router-link>
                </td>
                <td class="td_style">{{ `${row.referencia}` }}</td>
                <td class="td_style">{{ `${row.bodega}` }}</td>
                <td class="td_style">{{ row.cantidad }}</td>
                <td>
                  <ul
                    class="pull-center panel-settings panel-button-tab-right"
                  >
                    <li class="dropdown">
                      <a
                        class="pull-center dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                      >
                        <button class="btn btn-primary">
                          Opciones
                          <i class="fa fa-sort-down"></i>
                        </button>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                          <ul class="dropdown-settings">
                            <router-link
                              :to="{
                                name: 'editar-tarjetas',
                                params: { tarjetaId: row.id },
                              }"
                            >
                              <li class="td_style">
                                <a href="#">Ver/Editar</a>
                              </li>
                            </router-link>

                            <li class="divider"></li>
                            <li
                              @click="eliminar(row.id)"
                              class="td_style"
                            >
                              <a href="#">Eliminar</a>
                            </li>
                            <li class="divider"></li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
          ></datatable-pager>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
export default {
  name: 'tarjetas',
  components: {
    Loading,
  },
  data() {
    return {
      filter: '',
      loading: true,
      columns: [
        {
          label: 'ID',
          field: 'id',
          align: 'center',
        },
        {
          label: 'MARCA',
          field: 'marcas.marca',
          align: 'center',
        },
        {
          label: 'REFERENCIA',
          field: 'referencia',
          align: 'center',
        },
        {
          label: 'BODEGA',
          field: 'bodega',
          align: 'center',
        },
        { label: 'CANTIDAD', field: 'cantidad', align: 'center' },
        { label: 'ACCIONES', align: 'center' },
      ],
      row: [],
      page: 1,
      per_page: 20,
    };
  },
  created() {
    this.getTarjetas();
  },
  mounted() {},
  methods: {
    onCancel() {},
    eliminar(tarjetaId) {
      let data = {
        tarjetaId,
      };
      ServiceApi.post('/tarjetas/delete', data)
        .then(response => {
          this.getTarjetas();
        })
        .catch(err => {
          this.$noty.error('Ocurrio un error al eliminar la tarjeta');
          this.loading = false;
        });
    },
    getTarjetas() {
      this.loading = true;
      ServiceApi.get('/tarjetas/list')
        .then(response => {
          //console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.row = data.reverse();
          if (!data.length)
            this.$noty.warning('No se encontraron equipos creados.');
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar los equipos.'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
  },
};
</script>
